import { render, staticRenderFns } from "./BrowseTemplates.vue?vue&type=template&id=5a9a6676&scoped=true&"
import script from "./BrowseTemplates.vue?vue&type=script&lang=ts&"
export * from "./BrowseTemplates.vue?vue&type=script&lang=ts&"
import style0 from "./BrowseTemplates.vue?vue&type=style&index=0&id=5a9a6676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9a6676",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VCard,VContainer,VDivider,VIcon,VRow,VTreeview})
